/* ========================================================================== *\
	IMPORTS
\* ========================================================================== */

import bind from 'lodash/bind';
import forEach from 'lodash/forEach';
import isNil from 'lodash/isNil';

/* == IMPORTS =============================================================== */



/* ========================================================================== *\
	PRIVATE VARIABLES
\* ========================================================================== */

const
    moduleName = 'accordion',
    baseCssClass = `js-${moduleName}`,

    propertyNames = {
        baseElement: Symbol('baseElement')
    },
    selectors = {
        base: `.${baseCssClass}`,
        trigger: `.${baseCssClass}-trigger`,
    }

/* == PRIVATE VARIABLES ===================================================== */



/* ========================================================================== *\
	EVENT HANDLING
\* ========================================================================== */

function bindEvents() {
    const
        accordionHeaders = this[propertyNames.baseElement].querySelectorAll(selectors.trigger);

    forEach(accordionHeaders, accordionHeader => {
        accordionHeader.addEventListener('click', bind(onHeaderClicked, this));
    });
}

function onHeaderClicked(event) {
    const
        target = event.currentTarget.nextElementSibling,
        expanded = event.currentTarget.getAttribute('aria-expanded') === 'true' || false;

    event.currentTarget.setAttribute('aria-expanded', !expanded);
    target.hidden = expanded;
}

/* == EVENT HANDLING ======================================================== */



/* ========================================================================== *\
	PUBLIC API
\* ========================================================================== */

class Accordion {

    /* ====================================================================== *\
        CONSTRUCTOR
    \* ====================================================================== */

    constructor(baseElement) {
        if (isNil(baseElement)) {
            throw 'Unable to create instance of Exam, no base element has been provided';
        }

        this[propertyNames.baseElement] = baseElement;

        bindEvents.call(this); 
    }

    /* == CONSTRUCTOR ======================================================= */
}

/* == PUBLIC API ============================================================ */



/* ========================================================================== *\
	INITIALIZATION
\* ========================================================================== */

function init(baseElements = document.querySelectorAll(selectors.base)) {
    forEach(baseElements, baseElement => {
        new Accordion(baseElement);
    });
}

init();

/* == INITIALIZATION ======================================================== */



/* ========================================================================== *\
    EXPORTS
\* ========================================================================== */

export default Accordion;

/* == EXPORTS =============================================================== */